module.exports = __webpack_public_path__ + "img/shopGuide1-c.fcca0b21.jpg";